import styles from './OrderTimeline.module.css'

interface StatusLog {
    id: number
    old_status: string
    new_status: string
    changed_by_email: string
    note: string
    created: string
}

interface OrderTimelineProps {
    logs: StatusLog[]
}

const STATUS_LABELS: Record<string, string> = {
    pending: 'Pendiente',
    confirmed: 'Confirmado',
    printing: 'En impresión',
    shipped: 'Enviado',
    delivered: 'Entregado',
    cancelled: 'Cancelado',
}

export function OrderTimeline({ logs }: OrderTimelineProps) {
    if (logs.length === 0) {
        return <p className={styles.empty}>Sin historial de estados</p>
    }

    return (
        <div className={styles.timeline}>
            {logs.map((log) => (
                <div key={log.id} className={styles.item}>
                    <div className={styles.dot} />
                    <div className={styles.content}>
                        <p className={styles.transition}>
                            {STATUS_LABELS[log.old_status] || log.old_status} &rarr; {STATUS_LABELS[log.new_status] || log.new_status}
                        </p>
                        {log.note && <p className={styles.note}>{log.note}</p>}
                        <p className={styles.meta}>
                            {new Date(log.created).toLocaleString('es-PE')}
                            {log.changed_by_email && ` · ${log.changed_by_email}`}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    )
}
